<template>
  <div class="bg-primary">
    <div class="container">
      <ul class="d-flex justify-content-between align-items-center list-unstyled mb-0">
        <li class="nav-item">
          <a href="https://tdx.transportdata.tw/" class="nav-link ps-0 text-light">
            資料來源
          </a>
        </li>
        <li class="nav-item">
          <span class="text-light">Copyright © 2021 Yiren</span>
        </li>
      </ul>
    </div>
  </div>
</template>
